import * as React from "react";
import { Component } from "react";
import CurrencyInput from "react-currency-input";
import { ICurrencyFieldProps } from "./interfaces";

export default class CurrencyField extends Component<ICurrencyFieldProps> {
  public constructor(props: ICurrencyFieldProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  public render() {
    let className = "form-control";
    if (this.props.small && this.props.small) {
      className += " input-sm";
    }
    return (
      <CurrencyInput
        className={className}
        inputType={this.props.inputType}
        id={this.props.name}
        value={this.props.value}
        onChangeEvent={this.handleChange}
        precision={this.props.precision}
        prefix={this.props.prefix}
        selectAllOnFocus={this.props.selectAllOnFocus}
        allowEmpty={this.props.allowEmpty}
        disabled={this.props.disabled}
        allowNegative={this.props.allowNegative}
        tabIndex={this.props.disabled && this.props.disabled ? -1 : undefined}
      />
    );
  }

  private handleChange(event: any, maskedValue: any, floatValue: any) {
    this.props.onChange(event, this.props.object, floatValue);
  }
}



// WEBPACK FOOTER //
// ./src/components/common/CurrencyField.tsx